export default __webpack_public_path__ + "static/media/330_private03-jp-mobile.b1f39545.png";